import { motion, useReducedMotion } from "framer-motion";
import { SparklesIcon } from "lucide-react";

interface ChatPullTabProps {
	onOpen: () => void;
}

const ChatPullTab = ({ onOpen }: ChatPullTabProps) => {
	const reduceMotion = useReducedMotion();

	return (
		<motion.button
			type="button"
			onClick={onOpen}
			aria-label="Open AI Tutor"
			initial={{
				x: reduceMotion ? 0 : 48,
				y: "-50%",
				opacity: reduceMotion ? 1 : 0,
			}}
			animate={{ x: 0, y: "-50%", opacity: 1 }}
			transition={{ type: "spring", stiffness: 260, damping: 22 }}
			whileHover={reduceMotion ? undefined : { x: -5 }}
			whileTap={{ scale: 0.97 }}
			className="fixed top-2/3 -right-2 z-40 flex flex-col items-center gap-2.5 rounded-l-2xl bg-linear-to-b from-sky-500 to-indigo-500 py-4 pr-4.5 pl-3 text-white shadow-[0_10px_34px_-8px_rgba(56,120,240,0.55)] ring-1 ring-white/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
		>
			<motion.span
				animate={
					reduceMotion
						? undefined
						: { scale: [1, 1.2, 1], opacity: [0.85, 1, 0.85] }
				}
				transition={{
					duration: 1,
					repeat: Number.POSITIVE_INFINITY,
					repeatDelay: 3,
					ease: "easeInOut",
				}}
			>
				<SparklesIcon className="size-4" />
			</motion.span>
			<span className="font-medium text-sm leading-3 tracking-wider [writing-mode:vertical-rl]">
				AI Tutor
			</span>
		</motion.button>
	);
};

export default ChatPullTab;
